import { gql } from "@apollo/client";
const USER_BY_IPINID = gql`
  query getPlayerRankingsByTennisId($tennisId: String!, $citizenship: String!) {
    getPlayerRankingsByTennisId(tennisId: $tennisId, citizenship: $citizenship)
  }
`;
export default USER_BY_IPINID;
